import React, { FC } from 'react';
import classNames from 'classnames';
import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';
import { TypeTextBlockFields } from '@/core/generated-types';
import { RichText } from '@/components';
import { Document } from '@contentful/rich-text-types';
import styles from './TextBlock.module.scss';
import { BackgroundColorWrapper } from '@/components/common/BackgroundColorWrapper';
import { UniversalCta } from '../UniversalCta';

enum TEXT_BLOCK_STYLES {
  default = 'Default',
  leftAligned = 'Left aligned',
  rightAligned = 'Right aligned',
  centeredWithNarrowMargins = 'Centered text with narrow margins',
  leftAlignedWithNarrowMargins = 'Left-aligned text with narrow margins',
}

const getSectionStyle = (styleName: TEXT_BLOCK_STYLES) => {
  switch (styleName) {
    default: {
      return `text-center py-10 lg:py-20 ${styles.textBlock}`;
    }
    case TEXT_BLOCK_STYLES.leftAligned: {
      return `py-10 lg:py-20 ${styles.textBlock}`;
    }
    case TEXT_BLOCK_STYLES.rightAligned: {
      return `text-right py-10 lg:py-20 ${styles.textBlock}`;
    }
    case TEXT_BLOCK_STYLES.centeredWithNarrowMargins: {
      return `text-center pt-10 lg:pt-20 ${styles.textBlock}`;
    }
    case TEXT_BLOCK_STYLES.leftAlignedWithNarrowMargins: {
      return styles.textBlock;
    }
  }
};

const TextBlock: FC<TypeTextBlockFields> = ({
  entryName,
  title,
  titleAsH1,
  cta,
  ctaPosition,
  style,
  richText,
  backgroundColor,
  anchorId,
  maxWidth,
}) => {
  return (
    <BackgroundColorWrapper color={backgroundColor?.fields?.color} applyGutters>
      <section
        data-testid={`text-block-${entryName}`}
        id={anchorId}
        style={{ maxWidth }}
        className={classNames(
          'container mx-auto w-full px-4',
          getSectionStyle(style as TEXT_BLOCK_STYLES),
        )}
      >
        <HeaderText
          size={titleAsH1 ? HeaderSize.H1 : HeaderSize.H2}
          text={title}
          align="center"
          classes="max-w-[936px] mx-auto mb-8"
        />
        {cta && ctaPosition === 'Above text' && <UniversalCta link={cta} />}
        {richText && <RichText content={richText as Document} />}
        {cta && (!ctaPosition || ctaPosition === 'Below text') && (
          <UniversalCta link={cta} />
        )}
      </section>
    </BackgroundColorWrapper>
  );
};

export default React.memo(TextBlock);
